var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackNavigationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18887_7960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    transform: "rotate(90 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18887_7960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 11.3C9.01667 11.4833 8.925 11.7167 8.925 12C8.925 12.2833 9.01667 12.5167 9.2 12.7L12.3 15.8C12.4833 15.9833 12.7127 16.075 12.988 16.075C13.2627 16.075 13.5 15.975 13.7 15.775C13.8833 15.5917 13.975 15.3583 13.975 15.075C13.975 14.7917 13.8833 14.5583 13.7 14.375L11.325 12L13.725 9.6C13.9083 9.41667 14 9.18767 14 8.913C14 8.63767 13.9 8.4 13.7 8.2C13.5167 8.01667 13.2833 7.925 13 7.925C12.7167 7.925 12.4833 8.01667 12.3 8.2L9.2 11.3ZM2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26267 10.6167 2 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31267 18.175 4.025 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7377 9.31667 22 10.6167 22 12C22 13.3833 21.7377 14.6833 21.213 15.9C20.6877 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNavigationArrow);
export default __webpack_public_path__ + "static/media/backNavigationArrow.256c80b2950186c43028c1e843e47f12.svg";
export { ForwardRef as ReactComponent };